/* tslint:disable */
import {
  Library,
  Video,
  Image,
  Audio,
  Tag,
  PlayerGroup,
  RotationItem
} from '../index';

declare var Object: any;
export interface ScreenInterface {
  "id": string;
  "ScreenName"?: string;
  "IsTemplate": boolean;
  "isUniqueSchedule": boolean;
  "IsVertical": boolean;
  "ScreenData"?: any;
  "Description"?: string;
  "Width": number;
  "Height": number;
  "ScreenSizeInBytes": number;
  "ThumbnailFilename": string;
  "url"?: string;
  "urlThumb1"?: string;
  "urlThumb2"?: string;
  "urlThumb3"?: string;
  "urlThumb4"?: string;
  "MinimumScheduleTime": number;
  "Metadata"?: any;
  "Categories"?: string;
  "libraryId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  library?: Library;
  videos?: Video[];
  images?: Image[];
  audios?: Audio[];
  tags?: Tag[];
  playerGroups?: PlayerGroup[];
  rotationItems?: RotationItem[];
}

export class Screen implements ScreenInterface {
  "id": string;
  "ScreenName": string;
  "IsTemplate": boolean;
  "isUniqueSchedule": boolean;
  "IsVertical": boolean;
  "ScreenData": any;
  "Description": string;
  "Width": number;
  "Height": number;
  "ScreenSizeInBytes": number;
  "ThumbnailFilename": string;
  "url": string;
  "urlThumb1": string;
  "urlThumb2": string;
  "urlThumb3": string;
  "urlThumb4": string;
  "MinimumScheduleTime": number;
  "Metadata": any;
  "Categories": string;
  "libraryId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  library: Library;
  videos: Video[];
  images: Image[];
  audios: Audio[];
  tags: Tag[];
  playerGroups: PlayerGroup[];
  rotationItems: RotationItem[];
  constructor(data?: ScreenInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Screen`.
   */
  public static getModelName() {
    return "Screen";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Screen for dynamic purposes.
  **/
  public static factory(data: ScreenInterface): Screen{
    return new Screen(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Screen',
      plural: 'Screens',
      path: 'Screens',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "ScreenName": {
          name: 'ScreenName',
          type: 'string'
        },
        "IsTemplate": {
          name: 'IsTemplate',
          type: 'boolean',
          default: false
        },
        "isUniqueSchedule": {
          name: 'isUniqueSchedule',
          type: 'boolean',
          default: false
        },
        "IsVertical": {
          name: 'IsVertical',
          type: 'boolean',
          default: false
        },
        "ScreenData": {
          name: 'ScreenData',
          type: 'any'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "Width": {
          name: 'Width',
          type: 'number'
        },
        "Height": {
          name: 'Height',
          type: 'number'
        },
        "ScreenSizeInBytes": {
          name: 'ScreenSizeInBytes',
          type: 'number',
          default: 0
        },
        "ThumbnailFilename": {
          name: 'ThumbnailFilename',
          type: 'string'
        },
        "url": {
          name: 'url',
          type: 'string'
        },
        "urlThumb1": {
          name: 'urlThumb1',
          type: 'string'
        },
        "urlThumb2": {
          name: 'urlThumb2',
          type: 'string'
        },
        "urlThumb3": {
          name: 'urlThumb3',
          type: 'string'
        },
        "urlThumb4": {
          name: 'urlThumb4',
          type: 'string'
        },
        "MinimumScheduleTime": {
          name: 'MinimumScheduleTime',
          type: 'number',
          default: 0
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "libraryId": {
          name: 'libraryId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        library: {
          name: 'library',
          type: 'Library',
          model: 'Library',
          relationType: 'belongsTo',
                  keyFrom: 'libraryId',
          keyTo: 'id'
        },
        videos: {
          name: 'videos',
          type: 'Video[]',
          model: 'Video',
          relationType: 'hasMany',
          modelThrough: 'ScreenVideo',
          keyThrough: 'videoId',
          keyFrom: 'id',
          keyTo: 'screenId'
        },
        images: {
          name: 'images',
          type: 'Image[]',
          model: 'Image',
          relationType: 'hasMany',
          modelThrough: 'ScreenImage',
          keyThrough: 'imageId',
          keyFrom: 'id',
          keyTo: 'screenId'
        },
        audios: {
          name: 'audios',
          type: 'Audio[]',
          model: 'Audio',
          relationType: 'hasMany',
          modelThrough: 'ScreenAudio',
          keyThrough: 'audioId',
          keyFrom: 'id',
          keyTo: 'screenId'
        },
        tags: {
          name: 'tags',
          type: 'Tag[]',
          model: 'Tag',
          relationType: 'hasMany',
          modelThrough: 'TagScreen',
          keyThrough: 'tagId',
          keyFrom: 'id',
          keyTo: 'screenId'
        },
        playerGroups: {
          name: 'playerGroups',
          type: 'PlayerGroup[]',
          model: 'PlayerGroup',
          relationType: 'hasMany',
          modelThrough: 'PlayerGroupScreen',
          keyThrough: 'playerGroupId',
          keyFrom: 'id',
          keyTo: 'screenId'
        },
        rotationItems: {
          name: 'rotationItems',
          type: 'RotationItem[]',
          model: 'RotationItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'screenId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Screen.ts